<script>
export default {
  name: "ProfileEditPicture"
}
</script>

<template>
<div>
  ProfileEditPicture
</div>
</template>

<style scoped>

</style>